<template>
  <DefaultLayout background-image="green">
    <div class="flex flex-col items-center h-full">
      <div class="flex-1 flex flex-col justify-center">
        <div class="relative animation-wrapper">
          <img src="@/assets/images/misc/animation/sun.svg" class="sun" />
          <img src="@/assets/images/misc/animation/shot.svg" class="shot" />
          <img
            src="@/assets/images/misc/animation/machine.svg"
            class="machine"
          />
          <img src="@/assets/images/misc/animation/ways.svg" class="ways" />
          <img
            src="@/assets/images/misc/animation/icecoldshot.svg"
            class="icecoldshot"
          />
          <img
            src="@/assets/images/misc/animation/glass-left.svg"
            class="glass-left"
          />
          <img
            src="@/assets/images/misc/animation/glass-right.svg"
            class="glass-right"
          />
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>

<script setup lang="ts">
import DefaultLayout from "../layouts/DefaultLayout.vue";
import ShotAnimationImage from "./ShotAnimationImage.vue";
import { useGlobalStore } from "../stores/global";
import { onMounted } from "vue";

const globalStore = useGlobalStore();

const moveToGame = () => {
  setTimeout(() => {
    globalStore.changeStep("peopleCheck");
  }, 3700);
};

onMounted(() => {
  moveToGame();
});
</script>
<style lang="scss" scoped>
.animation-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 500px;
  height: 500px;
}

img {
  position: absolute;
  opacity: 0;
  animation-fill-mode: forwards;
}

.sun {
  z-index: 1;
  top: 30%;
  left: 40%;
  animation: sunIn 2s ease-out forwards;
  animation-delay: 1.2s;
}

@keyframes sunIn {
  0% {
    opacity: 1;
    transform: scale(0.6) rotate(0deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(-360deg);
  }
}

.shot,
.machine,
.ways,
.icecoldshot {
  z-index: 2;
  left: 50%;
  transform: translateX(-50%);
  animation: floatIn 0.6s ease-out forwards;
  animation-fill-mode: forwards;
  opacity: 0;
}

.machine {
  top: 49%;
  animation-delay: 1s;
}

.ways {
  top: 59%;
  animation-delay: 1.4s;
}

.icecoldshot {
  top: 62%;
  animation-delay: 1.6s;
}

.shot {
  top: 39%;
  left: 48%;
  animation-delay: 0.7s;
}

@keyframes floatIn {
  0% {
    opacity: 0;
    transform: translate(-50%, 30px);
  }
  60% {
    opacity: 1;
    transform: translate(-50%, -4px);
  }
  80% {
    opacity: 1;
    transform: translate(-50%, 4px);
  }

  100% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

.glass-right {
  top: 34%;
  left: 69.5%;
  z-index: 4;
  animation: dropIn 0.5s ease-out forwards;
  animation-delay: 1.9s;
  opacity: 0;
}

.glass-left {
  top: 32%;
  left: 63.6%;
  z-index: 3;
  animation: dropIn 0.5s ease-out forwards;
  animation-delay: 2.1s;
  opacity: 0;
}

@keyframes dropIn {
  0% {
    opacity: 0;
    transform: translateY(-50px);
  }
  60% {
    opacity: 1;
    transform: translateY(4px);
  }
  80% {
    opacity: 1;
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 639px) {
  .ways {
    width: 13.8rem;
  }

  .icecoldshot {
    width: 16.4rem;
  }
}
</style>
